import {
  InvestmentTransactionType,
  InvestmentTransactionDetails,
} from "hooks/investments/GetInvestmentTransactionsHook";
import {
  TYPE_LABELS,
  formatDate,
  formatNumber,
  FileCell,
  DotsMenu,
} from "./tableUtils";

interface TreasuryBondsTableProps {
  transactions: InvestmentTransactionType[];
  details: InvestmentTransactionDetails | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const TreasuryBondsTable = ({
  transactions,
  isOwn = false,
  onEditTx,
}: TreasuryBondsTableProps) => {
  return (
    <table className="itm-table">
      <thead>
        <tr>
          <th>Transakcja</th>
          <th>Data</th>
          <th>Ilość sztuk</th>
          <th>Umowa</th>
          <th>Koszt nabycia</th>
          <th>Cena nabycia</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
            <td>
              {tx.type === "buy" ? "+" : "-"}
              {tx.quantity ?? "—"}
            </td>
            <td>
              <FileCell tx={tx} />
            </td>
            <td>
              {formatNumber(tx.totalValue)} {tx?.currency?.currency}
            </td>
            <td>
              {formatNumber(tx.calculatedUnitPrice)} {tx?.currency?.currency}
            </td>
            <td>
              <DotsMenu
                tx={tx}
                onEdit={
                  isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TreasuryBondsTable;
